const { DateTime } = require('luxon')
const yup = require('yup')
const { labelify } = require('./helpers')
const mobileUserTypes = require('../mobile-user-types')
const levelsOfCare = require('../levels-of-care')
const { INVITATION_TARGETS } = require('../invitation-targets')

const phoneMatch = /[1-9]\d{2}-\d{3}-\d{4}/

const nameSchema = yup.object().shape({
  first: yup.string().required().default('').label('First name'),
  last: yup.string().required().default('').label('Last name'),
})

const shape = labelify({
  phone: yup
    .string()
    .when(['send', 'email'], {
      is: (send, email) => Boolean(send && !email),
      then: (s) => s.matches(phoneMatch, 'This phone number is not valid.').required('Either email or phone is required'),
    })
    .default(''),
  name: nameSchema,
  email: yup
    .string()
    .email()
    .when(['send', 'phone'], { is: (send, phone) => Boolean(send && !phone), then: (s) => s.required('Either email or phone is required') })
    .when('sendCommandCenterInvite', {
      is: true,
      then: (s) => s.required('Email is required to send the Command Center invite.'),
    })
    .default(''),
  profile: yup.mixed(),
  accountSetting: yup.mixed(),
  userType: yup.string().required().oneOf(mobileUserTypes).default(mobileUserTypes[0]),
  associatedWith: yup.string().default(''),
  trackAttendance: yup.boolean().nullable(),
  photosPermitted: yup.boolean().nullable().default(true),
  product: yup.string(),
  address: yup.string().default(''),
  birthdate: yup
    .mixed()
    .datetime(() => null)
    .test('in-future', '${path} is in the future', (value) => value < new Date()),
  levelOfCare: yup
    .string()
    .ensure()
    .oneOf(levelsOfCare, `Level of care must be one of: ${levelsOfCare.filter(Boolean).join(', ')}`),
  packages: yup.array().of(yup.string()).default([]),
  targetPlatforms: yup
    .array()
    .ensure()
    .of(yup.string().oneOf(Object.values(INVITATION_TARGETS))),
  send: yup.boolean().default(false),
  sendCommandCenterInvite: yup.boolean().default(false),
})

// This extra array parameter avoids circular dependency in the validation. See https://github.com/jquense/yup/issues/720#issuecomment-564591045
const invitationSchema = yup.object().shape(shape, [['email', 'phone']])

const invitationResponseSchema = invitationSchema.shape({
  expiredAt: yup.date().nullable(),
  invitedAt: yup.date().nullable(),
  inviteAcceptedAt: yup.date().nullable(),
})

const invitationImportSchema = invitationSchema.shape({
  birthdate: yup
    .date()
    .max(new Date(), ({ value }) => `Invalid birthdate: '${DateTime.fromJSDate(value).toLocaleString(DateTime.DATE_FULL)}'.`)
    .nullable()
    .transform((curr, orig) => (!orig ? null : curr)),
  moveInDate: yup
    .date()
    .nullable()
    .transform((curr, orig) => (!orig ? null : curr)),
  levelOfCare: yup
    .string()
    .ensure()
    .oneOf(levelsOfCare, ({ value }) => `Invalid level of care: '${value}'. Must be one of: ${levelsOfCare.filter(Boolean).join(', ')}`),
  address: yup
    .object({
      street1: yup.string(),
      street2: yup.string(),
      city: yup.string(),
      state: yup.string(),
      zip: yup.string(),
      country: yup.string(),
    })
    .optional()
    .transform((v) => (v === null ? undefined : v)),
})

module.exports = { invitationSchema, invitationImportSchema, invitationResponseSchema }
